import { useAppStore } from "@/store/appStore";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import Image from "@/components/image";
import Text from "@/components/text/text";
import Joystick from "../controls/exploration/joystick";
import { useModelViewerStore } from "@/store/modelViewerStore";

const ModelViewerLayout = ({ children }: { children: React.ReactNode }) => {
  const setPositionJoystickData = useModelViewerStore(
    (state) => state.setPositionJoystickData,
  );
  const setRotationJoystickData = useModelViewerStore(
    (state) => state.setRotationJoystickData,
  );

  const handlePositionJoystickMove = (x: number, y: number) => {
    setPositionJoystickData([x, y]);
  };

  const handlePositionJoystickRelease = () => {
    setPositionJoystickData([0, 0]);
  };

  const handleRotationJoystickMove = (x: number, y: number) => {
    setRotationJoystickData([x, y]);
  };

  const handleRotationJoystickRelease = () => {
    setRotationJoystickData([0, 0]);
  };

  const Joysticks = () => {
    return (
      <div className="absolute bottom-0 left-0 right-0">
        <div className="flex fixed justify-between bottom-0 w-full px-[20px] mb-[20px]">
          <Joystick
            onMove={handlePositionJoystickMove}
            onRelease={handlePositionJoystickRelease}
            topChild={
              <Image
                src="/assets/icon_joystick_up.png"
                height={24}
                width={24}
              />
            }
            bottomChild={
              <Image
                src="/assets/icon_joystick_down.png"
                height={24}
                width={24}
              />
            }
            leftChild={
              <Image
                src="/assets/icon_joystick_left.png"
                height={24}
                width={24}
              />
            }
            rightChild={
              <Image
                src="/assets/icon_joystick_right.png"
                height={24}
                width={24}
              />
            }
          />
          <Joystick
            onMove={handleRotationJoystickMove}
            onRelease={handleRotationJoystickRelease}
            topChild={<Text text="joystick_up" size={10} />}
            bottomChild={<Text text="joystick_down" size={10} />}
            leftChild={
              <Image
                src="/assets/icon_joystick_rotate_left.png"
                height={20}
                width={20}
              />
            }
            rightChild={
              <Image
                src="/assets/icon_joystick_rotate_right.png"
                height={20}
                width={20}
              />
            }
          />
        </div>
      </div>
    );
  };

  return (
    <div className="fullscreen_div">
      {children}
      <Joysticks />
    </div>
  );
};

export default ModelViewerLayout;
